export default "__VITE_ASSET__ffaa3b63__"